<template>
  <div class="session-detail">
    <div>
      <h2 class="text-h4">
        {{ session?.session_code || "-" }}
      </h2>
      <div class="d-flex gap-1">
        <span>✓ <span>{{ session?.status }}</span></span>
        <span>
          {{ session?.started_at | formatDate("DD-MM-YYYY") }} |
          {{ session?.started_at | formatDate("hh:mm: A") }} --
          {{ session?.completed_at | formatDate("hh:mm: A") }} | ({{
            session?.duration_minutes || 0
          }}
          mins)
        </span>
        <span>
          {{ session?.location_name }} | {{ session?.connector_type }}
          <span class="text-uppercase">
            {{ session?.power_type || 0 }} ({{
              session?.connector_power || 0
            }}kW)
          </span>
        </span>
      </div>
    </div>
    <v-card class="session-detail">
      <v-card-title>
        <div class="title">
          Charging Metrics
        </div>
      </v-card-title>
      <v-card-text>
        <div class="detail-grid">
          <div class="detail-item">
            <div class="detail-item-label">
              Battery Start
            </div>
            <div class="detail-item-value">
              {{ session?.start_soc || 0 }}%
            </div>
          </div>
          <div class="detail-item">
            <div class="detail-item-label">
              Battery End
            </div>
            <div class="detail-item-value">
              {{ session?.end_soc || 0 }}%
            </div>
          </div>
          <div class="detail-item">
            <div class="detail-item-label">
              Battery Added
            </div>
            <div class="detail-item-value">
              {{ session?.soc_added || 0 }}% ({{ session?.soc_added_kwh || 0 }}
              kWh)
            </div>
          </div>
          <div class="detail-item">
            <div class="detail-item-label">
              Energy Dispensed
            </div>
            <div class="detail-item-value">
              {{ session?.energy_consumed || 0 }} kWh
            </div>
          </div>
          <div class="detail-item">
            <div class="detail-item-label">
              Power Output
            </div>
            <div class="detail-item-value">
              {{ session?.connector_power || 0 }} kW
            </div>
          </div>
          <div class="detail-item">
            <div class="detail-item-label">
              Avg Charging Speed
            </div>
            <div class="detail-item-value">
              {{ session?.avg_power_kw || 0 }} kW
            </div>
          </div>
          <div class="detail-item">
            <div class="detail-item-label">
              Session Efficiency
            </div>
            <div class="detail-item-value">
              {{ session?.session_efficiency_percentage || 0 }}%
            </div>
          </div>
          <div class="detail-item">
            <div class="detail-item-label">
              Temperature
            </div>
            <div class="detail-item-value">
              {{ session?.temperature_celsius || "-" }}
            </div>
          </div>
        </div>
      </v-card-text>
    </v-card>
    <!-- Financials Details -->
    <v-card class="financial-detail">
      <v-card-title>
        <div class="title">
          Financial Details
        </div>
      </v-card-title>
      <v-card-text>
        <table>
          <tbody>
            <tr>
              <td>Unit Cost</td>
              <td>PKR {{ session?.financials?.unit_cost || 0 }}/kWh</td>
            </tr>
            <tr>
              <td>Energy Delivered</td>
              <td>{{ session?.financials?.energy_delivered || 0 }} kWh</td>
            </tr>
            <tr>
              <td>Base Cost</td>
              <td>PKR {{ session?.financials?.base_cost || 0 }}</td>
            </tr>
            <tr>
              <td>Discount</td>
              <td>PKR {{ session?.financials?.discount || 0 }} (None)</td>
            </tr>
            <tr>
              <td>Tax ({{ session?.financials?.tax_percentage }}%)</td>
              <td>PKR {{ session?.financials?.tax_cost }}</td>
            </tr>
            <tr>
              <td>TOTAL</td>
              <td>PKR {{ session?.financials?.total }}</td>
            </tr>
          </tbody>
        </table>
      </v-card-text>
    </v-card>
    <!-- Payment Information -->
    <v-card class="payment-information">
      <v-card-title>
        <div class="title">
          Payment Information
        </div>
      </v-card-title>
      <v-card-text>
        <div class="detail-grid">
          <div class="detail-item">
            <div class="detail-item-label">
              Payment Method
            </div>
            <div class="detail-item-value">
              Visa Card (****{{ session?.payment?.card_last_four || "0000" }})
            </div>
          </div>
          <div class="detail-item">
            <div class="detail-item-label">
              Status
            </div>
            <div
              class="detail-item-value"
              style="color: var(--themeColor)"
            >
              {{ session?.payment?.payment_status }}
            </div>
          </div>
          <div class="detail-item">
            <div class="detail-item-label">
              Transaction ID
            </div>
            <div class="detail-item-value">
              {{ session?.payment?.transaction_code || "-" }}
            </div>
          </div>
          <div class="detail-item">
            <div class="detail-item-label">
              Payment Time
            </div>
            <div class="detail-item-value">
              {{ session?.payment?.paid_at || "-" }}
            </div>
          </div>
        </div>
      </v-card-text>
    </v-card>
    <!--  -->
    <v-card class="user-feedback">
      <v-card-title>
        <div class="title">
          User Feedback
        </div>
      </v-card-title>
      <v-card-text>
        <div class="detail-grid">
          <div class="detail-item">
            <div class="detail-item-label">
              Rating
            </div>
            <div class="detail-item-value">
              ⭐⭐⭐⭐⭐ (5 stars)
            </div>
          </div>
          <div class="detail-item">
            <div class="detail-item-label">
              Review
            </div>
            <div
              class="detail-item-value"
              style="color: var(--medium-gray)"
            >
              Great charging speeds, clean facilities
            </div>
          </div>
          <div class="detail-item">
            <div class="detail-item-label">
              Photos Uploaded
            </div>
            <div class="detail-item-value">
              3
            </div>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  components: {},
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      session: null,
    };
  },
  computed: {
    ...mapGetters({
      loading: "usersAnalyticsDashboard/getLoading",
    }),
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      const params = {
        id: this.item?.id,
      };
      await this.$store
        .dispatch("usersAnalyticsDashboard/sessionDetails", params)
        .then((res) => {
          this.session = res;
        });
    },
  },
};
</script>
<style lang="sass" scoped>
$spacing : 1rem

.v-card__title
    padding-top: 1rem !important
    text-align: left !important
    .title
        font-size: 14px
        font-weight: bold
        padding-bottom: 0.5rem

.session-detail
  margin-bottom: $spacing
  h2
    color: $theme-color


.detail-grid
  display: grid
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr))
  gap: 15px

.detail-item
  padding: 15px
  border-radius: 4px
  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12)

  .detail-item-label
    font-size: 11px
    color: gray
    text-transform: uppercase
    margin-bottom: 5px


  .detail-item-value
    font-size: 18px
    font-weight: bold
    text-transform: capitalize
    color: $theme-color


.financial-detail
  margin-bottom: $spacing
  table
    width: 100%
    tr
      td
        border-bottom: 1px solid gray !important
      td:first-child
        padding: 8px 0
      td:last-child
        text-align: right
        padding: 8px 0

    tr:last-child
      td
        border-bottom: none !important
        font-size: 20px !important
        font-weight: bold
        color : $theme-color !important


.payment-information, .user-feedback
  margin-bottom: $spacing
</style>
